/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconScan = createReactComponent("scan", "IconScan", [
  ["path", { d: "M4 7v-1a2 2 0 0 1 2 -2h2", key: "svg-0" }],
  ["path", { d: "M4 17v1a2 2 0 0 0 2 2h2", key: "svg-1" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v1", key: "svg-2" }],
  ["path", { d: "M16 20h2a2 2 0 0 0 2 -2v-1", key: "svg-3" }],
  ["path", { d: "M5 12l14 0", key: "svg-4" }]
]);

export { IconScan as default };
//# sourceMappingURL=IconScan.js.map
